import React from 'react'
import queryString from 'query-string'
import * as R from 'ramda'

import { DateCell } from 'components/shared/Table/common/Cells/DateCell/DateCell'
import { JobProgressCell } from 'components/shared/Table/common/Cells/JobProgressCell/JobProgressCell'
import { PrimaryCell } from 'components/shared/Table/common/Cells/PrimaryCell/PrimaryCell'
import { TextCell } from 'components/shared/Table/common/Cells/TextCell/TextCell'
import { Table } from 'components/shared/Table/Table'

import { getDefaultQueryParams } from 'components/pages/Jobs/model'
import { checkActiveModule } from 'utils/modules'
import { getTab } from './model'

import jobStyles from '../../JobsListing.module.scss'
import styles from '../../../JobDetails/CandidatesTable/CandidatesTable.module.scss'

export const JobsTableBody = ({
  model,
  rowSelection,
  isFetching,
  placeholder,
  handleStep,
}) => (
  <Table.Body placeholder={placeholder} isLoaded={R.not(isFetching)}>
    {R.map(
      ({
        id,
        original,
        getIsSelected,
        getIsSomeSelected,
        getToggleSelectedHandler,
      }) => {
        const {
          candidates_count,
          department,
          description,
          id: resourceId,
          modules,
          name,
          positions,
          selection_stage,
          start_date,
          updated,
          active,
        } = original

        const tab = getTab({ selection_stage })
        const defaultQueryParams = getDefaultQueryParams({
          activeTab: tab,
        })

        const basic = `/projects/${resourceId}/${tab}`
        const tabs = `${basic}?${queryString.stringify(defaultQueryParams)}`

        const to = R.equals(selection_stage, 1) ? basic : tabs

        const hasInterviewModule = checkActiveModule(modules?.interview)

        return (
          <Table.Row
            key={id}
            type="body"
            onChange={getToggleSelectedHandler()}
            isChecked={getIsSelected()}
            isIndeterminate={getIsSomeSelected()}
            isSelected={rowSelection[id]}
            isInactive={!active}
            hasCheckbox
          >
            <PrimaryCell primary={name} description={description} to={to} />
            <TextCell text={department.name} />
            <TextCell text={positions} />
            <TextCell text={candidates_count} />
            <DateCell date={start_date} hasNowLabel />
            <DateCell date={updated} hasNowLabel />
            <JobProgressCell
              progress={selection_stage}
              type="project"
              onClick={handleStep(resourceId)}
              {...{ hasInterviewModule }}
            />
          </Table.Row>
        )
      },
      model.rows,
    )}
  </Table.Body>
)

